import React, { Component, Fragment } from "react";
import { Link, browserHistory } from "react-router";
import { connect } from "react-redux";
import Loader from "../common/Loader";
import Footer from "./Footer.jsx";
import "./Layout.scss";

class Layout extends Component {
  state = {
    search: "",
    navs: [
      // { uri: '/', title: 'Live' },
      // { uri: '/backtest', title: 'Backtest' },
      { uri: "/myclients", title: "My Clients", beta: "" },
      { uri: "/myportfolios", title: "My Portfolios", beta: "" },
      // { uri: '#', title: 'Related Research' },
      // { uri: "/create", title: "Create Portfolio", beta: "" },
      {
        uri: "/buildPortfolio",
        title: "Build a Portfolio (Advisor)",
        beta: "",
      },
      // { uri: "/compare", title: "Compare Portfolio", beta: "" },
      // { uri: "#", title: "Create Portfolio", beta: "" },
      { uri: "/create", title: "Create Portfolio", beta: "" },
      // { uri: "#", title: "Compare Portfolio", beta: "" },
      //      { uri: "/compare", title: "Compare Portfolio", beta: "" },
      // { uri: "/retire", title: "Retirement", beta: "" },
      // { uri: '/create_portfolio', title: 'Create' },
    ],
    breadcrumbs: [],

    // steps to zero on click navigation
    activeSteps: null,
    simulations: true,
    theme_based: true,
    my_clients: true,
    build_a_portfolio:true,
    custom_portfolio: true,
    asset_allocation: true,
    manager_selection: true,
    model_portfolios: true,
    create_portfolio: true,
    my_universe:true,
    userName: "",
    first_name:"",
    last_name:"",
    company:"",
    region:""
  };

  componentWillMount() {
    // this.props.checkLogin()
    // getting user name
    let obj = window.localStorage._user
      ? JSON.parse(window.localStorage._user)
      : false;

    if (obj) {
      let name = obj["username"];

      this.setState({
        userName: name,
      });
    }

    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
//      let simulations = _user_preferences["simulations"];
//
//      this.setState({
//        simulations: simulations,
//      });
        this.setPreferences(_user_preferences);
    }

    console.log({ process: process.env, node: process.env.NODE_ENV });
  }

  setPreferences = (up) => {
      let simulations       = (false === up['simulations'])        ? false : true;
      let theme_based       = (false === up['theme_based'])        ? false : true;
      let my_clients        = (false === up['my_clients'])         ? false : true;
      let custom_portfolio  = (false === up['custom_portfolio'])   ? false : true;
      let asset_allocation  = (false === up['asset_allocation'])   ? false : true;
      let manager_selection = (false === up['manager_selection'])  ? false : true;
      let model_portfolios  = (false === up['model_portfolios'])   ? false : true;
      let create_portfolio  = (false === up['create_portfolio'])   ? false : true;
      let my_universe       = (false === up['my_universe'])        ? false : true;

      let build_a_portfolio = custom_portfolio || asset_allocation || manager_selection || model_portfolios;
      let first_name        = up["first_name"] ? up["first_name"] : "";
      let last_name         = up["last_name"] ? up["last_name"] : "";
      let company           = up["company"] ? up["company"] : "";
      let region            = up["region"] ? up["region"] : "";

      this.setState({
        first_name:first_name,
        last_name:last_name,
        company:company,
        region:region
      });

      if(process.env.NODE_ENV === "production"){
      //set the various view preferences only if this is production env
          this.setState({
            simulations: simulations,
            theme_based: theme_based,
            my_clients: my_clients,
            custom_portfolio:custom_portfolio,
            asset_allocation:asset_allocation,
            manager_selection:manager_selection,
            model_portfolios:model_portfolios,
            build_a_portfolio:build_a_portfolio,
            create_portfolio:create_portfolio,
            my_universe:my_universe
          });
      }
  }


  componentWillReceiveProps(nextProps) {
    let _user_preferences = window.localStorage._user_preferences
      ? JSON.parse(window.localStorage._user_preferences)
      : false;

    if (_user_preferences) {
//      let simulations = _user_preferences["simulations"];
//
//      this.setState({
//        simulations: simulations,
//      });
        this.setPreferences(_user_preferences);
    }
  }

  setPath = (paths) => {
    this.setState({ breadcrumbs: paths });
  };

  handleChangeSearch(e) {
    this.setState({ search: e.target.value });
  }

  doSearch(e) {
    e.preventDefault();
  }

  logout() {
    this.props.logout();
    this.props.resetBuildAPortfolio();
    this.props.resetIQCIOliveMyUniverse();
    this.props.resetCreatePort();
    this.props.resetMyClients();
    browserHistory.push("/login");
  }

  contactAdmin = () => {
    alert("Please Contact Your Admin.");
  };

  cioFlow = () => {
    this.props.setCreatePortfolioType("CIO");
    this.navigationHandler("/create");

  };

  setActiveStepToZero = (title) => {
    console.log({ title });
    this.setState(
      {
        activeSteps: 0,
      },
      () => {
        this.props.setActiveStep(this.state.activeSteps);
      }
    );

    if (
      title.toLowerCase() == "create portfolio" &&
      this.props.stepsCount > 0
    ) {
      this.props.createPortfolioResetDataAlert(true);
    }
  };
  navigationHandler = (uri) => {
    // if (
    //   uri !== "/buildPortfolio/customPortfolio" &&
    //   uri !== "/buildPortfolio/managerSelection"
    // ) {
    //   this.props.resetBuildAPortfolio();
    // }

    if (this.props.stepsCount > 0 && uri !== "/create") {
      this.props.createStepAssociatedRoute(uri);
    } else {
      this.props.createStepAssociatedRoute("");
    }

    if (this.props.stepsCount > 0) {
      this.setState(
        {
          activeSteps: 0,
        },
        () => {
          this.props.setActiveStep(this.state.activeSteps);
        }
      );
      this.props.createPortfolioResetDataAlert(true);
      // alert("my alert");
    } else {
      browserHistory.push(uri);
      this.props.createStepAssociatedRoute("");
    }

    // resetting questionnaire
    this.props.resetQuestionnaireStepAndClient();
    // resetting myClients
    this.props.resetMyClients();
  };

  render() {
    const { pathname } = this.props.location;
    const { breadcrumbs, simulations, theme_based, my_clients, create_portfolio, custom_portfolio, asset_allocation, manager_selection, model_portfolios, build_a_portfolio, company, region, first_name, last_name, my_universe } = this.state;
    const { setPath } = this;
    const {
      myUniverse,
      setBuildAPortfolioType,
      resetBuildAPortfolioID,
      build_a_portfolio_type,
      resetBuildDirectReview,
      resetQuestionnaireStepAndClient,
    } = this.props;

    return (
      <div className="root-content">
        <header className="page-header">
          <nav className="navbar mega-menu" role="navigation">
            <div className="container-fluid">
              <div className="clearfix">
                <a id="index" className="page-logo" href="/">
                  <img src="/images/logo.png" alt="Logo" />
                </a>
                {/*<form className="search" onSubmit={this.doSearch.bind(this)}>
									<input type="name" className="form-control" name="query" value={this.state.search} onChange={this.handleChangeSearch.bind(this)} placeholder="Search..." />
									<span className="btn submit md-skip" onClick={this.doSearch.bind(this)}>
										<i className="fa fa-search"></i>
									</span>
								</form>*/}
                <div className="topbar-actions">
                  <ul className="navbar">
                    {/*
                      this.state.navs.map((nav, i) => (
                      <li
                        key={i}
                        className={
                          pathname == nav.uri
                            ? "navbar__item selected"
                            : "navbar__item"
                        }
                        // blocking direct changing tab when creating portfolio
                        style={{
                          pointerEvents:
                            this.props.stepsCount > 0 &&
                            nav.title !== "Create Portfolio"
                              ? "none"
                              : "all",
                        }}
                        onClick={() =>
                          nav["title"] !== "My Portfolios"
                            ? this.setActiveStepToZero(nav["title"])
                            : null
                        }
                      >
                        <Link to={nav.uri} className="text-uppercase">
                          {nav.title}{" "}
                          <sup>
                            {" "}
                            <small>{nav.beta}</small>{" "}
                          </sup>
                        </Link>
                      </li>
                    ))
                    */}
                    {this.state.navs.map((nav, i) => (
                      <Fragment key={i}>
                        { (nav.uri === "/buildPortfolio" && build_a_portfolio) ? (
                          <BuildAPortfolioRoute
                            title={nav.title}
                            navigationHandler={this.navigationHandler}
                            activeClassName={
                              pathname ===
                              ("/buildPortfolio/customPortfolio" ||
                                "/buildPortfolio/managerSelection")
                                ? "navbar__item selected"
                                : "navbar__item"
                            }
                            setBuildAPortfolioType={setBuildAPortfolioType}
                            resetBuildAPortfolioID={resetBuildAPortfolioID}
                            build_a_portfolio_type={build_a_portfolio_type}
                            simulations={simulations}
                            contactAdmin={this.contactAdmin}
                            resetBuildDirectReview={resetBuildDirectReview}
                            resetQuestionnaireStepAndClient={
                              resetQuestionnaireStepAndClient
                            }
                              custom_portfolio={custom_portfolio}
                              asset_allocation={asset_allocation}
                              manager_selection={manager_selection}
                              model_portfolios={model_portfolios}
                          />
                        ) : (nav.uri === "/create" && create_portfolio) ? (
                          <CreatePortfolioRoute
                            title={nav.title}
                            activeClassName={
                              pathname === "/create"
                                ? "navbar__item selected"
                                : "navbar__item"
                            }
                            simulations={simulations}
                            contactAdmin={this.contactAdmin}
                            navigationHandler={this.navigationHandler}
                            setCreatePortfolioType={
                              this.props.setCreatePortfolioType
                            }
                            theme_based={theme_based}
                            cioFlow={this.cioFlow}
                          />
                        ) : (nav.uri ===  "/myclients" && my_clients) ? (
                          <li
                            key={i} className={ pathname === nav.uri ? "navbar__item selected" : "navbar__item"}
                            onClick={() => this.navigationHandler(nav["uri"])}
                              >
                              <a className="text-uppercase">{nav.title}</a>
                          </li>
                        ) : (nav.uri !==  "/myclients" && nav.uri !== "/buildPortfolio" && nav.uri !== "/create") ? (
                          <li
                            key={i}
                            className={
                              pathname === nav.uri
                                ? "navbar__item selected"
                                : "navbar__item"
                            }
                            onClick={() =>
                              simulations === false &&
                              nav.title !== "My Portfolios" &&
                              process.env.NODE_ENV === "production"
                                ? this.contactAdmin()
                                : nav["title"] !== "My Portfolios" &&
                                  nav.uri !== "/buildPortfolio"
                                ? this.setActiveStepToZero(nav["title"])
                                : null
                            }
                          >
                            {simulations !== false ? (
                              <a
                                // href="#"
                                className="text-uppercase"
                                onClick={() =>
                                  this.navigationHandler(nav["uri"])
                                }
                              >
                                {nav.title}{" "}
                                <sup>
                                  {" "}
                                  <small>{nav.beta}</small>{" "}
                                </sup>
                              </a>
                            ) : (
                              <a href="/" className="text-uppercase">
                                {nav.title}{" "}
                                <sup>
                                  {" "}
                                  <small>{nav.beta}</small>{" "}
                                </sup>
                              </a>
                            )}
                          </li>
                        ) : ""}
                      </Fragment>
                    ))}

                    <li
                      className="navbar__item"
                      // blocking direct changing tab when creating portfolio
                      // style={{
                      //   pointerEvents:
                      //     this.props.stepsCount > 0 ? "none" : "auto",
                      // }}
                    >
                      <div className="btn-group-img btn-group">
                        <button
                          type="button"
                          className="dropdown-toggle"
                          data-toggle="dropdown"
                          data-hover="dropdown"
                          data-close-others="true"
                        >
                          <span>
                            {/* {this.props.user.username}{" "} */}
                            {this.state.userName}
                            <i className="fa fa-user" />
                            <i className="fa fa-angle-down" />
                          </span>
                        </button>
                        <ul className="dropdown-menu-v2" role="menu">
                          {
                            <Fragment>
                            <li className="nav_list">Hello {first_name} {last_name}</li>
                            <li className="nav_list"
                                style={{fontSize:"smaller", color:"#cccccc", textTransform:"uppercase"}}>
                                {company} {region}
                            </li>
                            <li className="divider"> </li>
                            </Fragment>
                            /* <li>
                            <a href="page_user_profile_1.html">
                              <i className="icon-user"></i> My Profile
                              <span className="badge badge-danger">1</span>
                            </a>
                          </li>
                          <li>
                            <a href="app_calendar.html">
                              <i className="icon-calendar"></i> My Calendar
                            </a>
                          </li>
                          <li>
                            <a href="app_inbox.html">
                              <i className="icon-envelope-open"></i> My Inbox
                              <span className="badge badge-danger"> 3 </span>
                            </a>
                          </li>
                          <li>
                            <a href="app_todo_2.html">
                              <i className="icon-rocket"></i> My Tasks
                              <span className="badge badge-success"> 7 </span>
                            </a>
                          </li> */}
                          {/*<li>
                            <a href="mymodels">
                              MY MODELS
                            </a>
                          </li>*/}
                          {my_universe &&
                              <li
                                onClick={() =>
                                  simulations === false &&
                                  process.env.NODE_ENV === "production"
                                    ? this.contactAdmin()
                                    : this.navigationHandler("/myuniverse")
                                }
                                className="nav_list"
                              >
                                {/* <a href="myuniverse" > */}
                                MY UNIVERSE
                                {myUniverse.length > 0 ? (
                                  <span className="badge badge-danger">
                                    {" "}
                                    {myUniverse.length > 0 ? 1 : null}
                                  </span>
                                ) : null}
                                {/* </a> */}
                              </li>
                            }
                          <li className="divider"> </li>
                          {/* <li>
                            <a href="page_user_lock_1.html">
                              <i className="icon-lock"></i> Lock Screen{" "}
                            </a>
                          </li> */}
                          <li>
                            <a href="#" onClick={this.logout.bind(this)}>
                              <i className="icon-key"></i> Log Out
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ol className="breadcrumb">
              <li>
                <a href="/">Home</a>
              </li>
              {breadcrumbs.map((b, i) => (
                <li key={i} className={!breadcrumbs[i + 1] ? "active" : ""}>
                  {b}
                </li>
              ))}
            </ol>
          </nav>
        </header>
        <div className="container-wrapper">
          <div className="container-fluid head">
            <div className="overlay-loader">
              <Loader isLoading={this.props.loader.isLoading} />
              {React.cloneElement(this.props.children, { setPath: setPath })}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}


const BuildAPortfolioRoute = ({
  title,
  activeClassName,
  navigationHandler,
  setBuildAPortfolioType,
  resetBuildAPortfolioID,
  build_a_portfolio_type,
  simulations,
  contactAdmin,
  resetBuildDirectReview,
  resetQuestionnaireStepAndClient,
  custom_portfolio,
  asset_allocation,
  manager_selection,
  model_portfolios
}) => (
  <li className={activeClassName}>
    <div className="btn-group-img btn-group" style={{ padding: "0 10px" }}>
      <button
        type="button"
        className="dropdown-toggle"
        data-toggle="dropdown"
        data-hover="dropdown"
        data-close-others="true"
        onClick={() =>
          simulations === false && process.env.NODE_ENV === "production"
            ? contactAdmin()
            : null
        }
      >
        <span>{title}</span>
      </button>
      <ul
        className="dropdown-menu-v2"
        role="menu"
        style={{
          display: `${
            simulations === false && process.env.NODE_ENV === "production"
              ? "none"
              : ""
          }`,
        }}
      >
        {custom_portfolio &&
            <li
              onClick={() => {
                setBuildAPortfolioType("customPortfolio");
                resetBuildAPortfolioID();
                navigationHandler(`/buildPortfolio/customPortfolio`);
                resetBuildDirectReview();
                resetQuestionnaireStepAndClient();
              }}
              className={`nav_list ${
                build_a_portfolio_type === "customPortfolio"
                  ? "build_nav_active"
                  : "build_nav_not_active"
              }`}
            >
              CUSTOM PORTFOLIO
            </li>
        }
        {manager_selection &&
          <Fragment>
            <li className="divider"> </li>
            <li>
              <Link
                to="/buildPortfolio/managerSelection"
                onClick={() => {
                  setBuildAPortfolioType("managerSelection");
                  resetBuildAPortfolioID();
                  resetBuildDirectReview();
                  resetQuestionnaireStepAndClient();
                }}
                className={`${
                  build_a_portfolio_type === "managerSelection"
                    ? "build_nav_active"
                    : "build_nav_not_active"
                }`}
              >
                MANAGER SELECTION
              </Link>
            </li>
         </Fragment>
        }
        {asset_allocation &&
        <Fragment>
            <li className="divider"> </li>
            <li>
              <Link
                to="/buildPortfolio/assetAllocationFunds"
                onClick={() => {
                  setBuildAPortfolioType("assetAllocationFunds");
                  resetBuildAPortfolioID();
                  resetBuildDirectReview();
                  resetQuestionnaireStepAndClient();
                }}
                className={`${
                  build_a_portfolio_type === "assetAllocationFunds"
                    ? "build_nav_active"
                    : "build_nav_not_active"
                }`}
              >
                ASSET ALLOCATION FUNDS
              </Link>
            </li>
        </Fragment>
        }
        {model_portfolios &&
        <Fragment>
            <li className="divider"> </li>
            <li>
              <Link
                to="/buildPortfolio/modelPortfolios"
                onClick={() => {
                  setBuildAPortfolioType("modelPortfolios");
                  resetBuildAPortfolioID();
                  resetBuildDirectReview();
                  resetQuestionnaireStepAndClient();
                }}
                className={`${
                  build_a_portfolio_type === "modelPortfolios"
                    ? "build_nav_active"
                    : "build_nav_not_active"
                }`}
              >
                MODEL PORTFOLIOS
              </Link>
            </li>
          </Fragment>
        }
      </ul>
    </div>
  </li>
);


const CreatePortfolioRoute = ({
  title,
  activeClassName,
  simulations,
  contactAdmin,
  navigationHandler,
  setCreatePortfolioType,
  theme_based,
  cioFlow
}) => (
      <li className={activeClassName}>
        <div className="btn-group-img btn-group" style={{ padding: "0 10px" }}>
          <button
            type="button"
            className="dropdown-toggle"
            data-toggle="dropdown"
            data-hover="dropdown"
            data-close-others="true"
            onClick={() =>
              simulations === false && process.env.NODE_ENV === "production"
                ? contactAdmin()
                : theme_based?null:cioFlow()
            }
          >
            <span>{title}</span>
          </button>
          {theme_based &&
              <ul
                className="dropdown-menu-v2"
                role="menu"
                style={{
                  display: `${
                    simulations === false && process.env.NODE_ENV === "production"
                      ? "none"
                      : ""
                  }`,
                }}
              >
                <li
                  className={`nav_list ${"build_nav_not_active"}`}
                  onClick={() => {
                    setCreatePortfolioType("CIO");
                    navigationHandler("/create");
                  }}
                >
                  CIO
                </li>
                <li className="divider"> </li>
                <li
                  className={`nav_list ${"build_nav_not_active"}`}
                  onClick={() => {
                    setCreatePortfolioType("THEME_BASED");
                    navigationHandler("/create");
                  }}
                >
                  THEME BASED
                </li>
              </ul>
            }
        </div>
      </li>
);
export default connect(
  ({
    user,
    loader,
    create: {
      steps: { stepsCount },
    },
    iqciolive: { myUniverse },
    buildPortfolio: { build_a_portfolio_type },
  }) => ({
    user,
    loader,
    stepsCount,
    myUniverse,
    build_a_portfolio_type,
  }),
  (dispatch) => ({
    checkLogin: () => dispatch({ type: "CHECK_LOGIN" }),
    logout: () => dispatch({ type: "LOGOUT" }),
    setActiveStep: () => dispatch({ type: "SET_LAYOUT_ACTIVE_STEP_TO_ZERO" }),
    createPortfolioResetDataAlert: (value) =>
      dispatch({
        type: "SET_CREATE_PORTFOLIO_DATA_RESET_ALERT",
        payload: value,
      }),
    createStepAssociatedRoute: (payload) =>
      dispatch({
        type: "SET_CREATE_PORTFOLIO_ASSOCIATED_ROUTE",
        payload,
      }),
    resetBuildAPortfolio: () => {
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO",
      });
    },
    setBuildAPortfolioType: (payload) => {
      dispatch({
        type: "BUILD_A_PORTFOLIO_TYPE",
        payload,
      });
    },
    resetBuildAPortfolioID: () => {
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO_ACTIVE_ID",
      });
    },
    resetIQCIOliveMyUniverse: (payload) =>
      dispatch({
        type: "SET_IQCIO_LIVE_MY_UNIVERSE",
        payload: [],
      }),

    resetBuildDirectReview: () =>
      dispatch({
        type: "RESET_BUILD_DIRECT_REVIEW",
      }),
    resetCreatePort: () => dispatch({ type: "RESET_PORTFOLIO_CREATE" }),
    resetQuestionnaireStepAndClient: () =>
      dispatch({
        type: "RESET_BUILD_A_PORTFOLIO_QUESTIONNAIRE_STEP_AND_NEWCLIENTACTIVE",
      }),
    resetMyClients: () =>
      dispatch({
        type: "RESET_MYCLIENTS_ANALYSE",
      }),
    setCreatePortfolioType: (payload) =>
      dispatch({
        type: "SET_CREATE_PORTFOLIO_TYPE",
        payload,
      }),
  })
)(Layout);



// WEBPACK FOOTER //
// ./src/components/common/Layout.jsx